import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const H2 = styled.h2`
  font-weight: 900;
  &,
  * {
    font-size: 36px;
    line-height: 48px;
  }

  ${media.tablet`
    &, * {
      font-size: 26px;
      line-height: 32px;
    }`}
`

export default H2
